import React from 'react';
import styled from 'styled-components';

const NavWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 0 22.5rem;
  height: 3.125rem;
  border-bottom: 4px solid #1c92c1;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  color: #1b1b1b;

  span {
    border-right: 1px solid #e5e5e5;
    flex: 1;
    text-align: center;
    cursor: pointer;
  }

  span:last-child {
    border-right: 0;
  }

  @media screen and (max-width: 1199px) {
    padding: 0;
    border-bottom: 1px solid #e5e5e5;
    filter: none;
    font-size: 0.75rem;
    color: #1b1b1b;

    span {
      border-right: 0;
      line-height: 3.125rem;
    }
  }

  @media screen and (max-width: 359px) {
    font-size: 0.3rem;
  }
`;

const Nav = ({ onSelect }) => {
  return (
    <NavWrapper>
      <span onClick={onSelect}>전체</span>
      <span onClick={onSelect}>냉동수산부</span>
      <span onClick={onSelect}>패류부</span>
      <span onClick={onSelect}>선어도매부</span>
      <span onClick={onSelect}>건어부</span>
      <span onClick={onSelect}>젓갈부</span>
    </NavWrapper>
  );
};

export default Nav;
